export const ADMIN_VIEW_CONST = 'adm_v';
